import { render, staticRenderFns } from "./DraggableListsLayers.vue?vue&type=template&id=22ca1014&scoped=true&"
import script from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
export * from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsLayers.vue?vue&type=style&index=0&id=22ca1014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca1014",
  null
  
)

export default component.exports